import { Badge, Chip, CircularProgress, Sheet, Typography } from "@mui/joy";
import { Box, Tooltip } from "@mui/material";
import Divider from "@mui/material/Divider";
import Grid from "@mui/material/Grid";
import moment from "moment";
import { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { AppConfig } from "../environement";
import { RouterConfig } from "../hooks/config/routerConfig";
import Id from "../hooks/id/id";
import { useEmail } from "../redux/local420Emails/emailHooks";

export default function EmailPage() {
  const [anchorEl, setAnchorEl] = useState();
  const params = useParams();
  const emailID = parseInt(params.emailID);
  const { email } = useEmail(emailID);
  const pathnames = location.pathname.split("/").filter((x) => x);
  const navigate = useNavigate();
  const isEmailsPage = pathnames.indexOf("emails") >= 0;
  const [key, setKey] = useState(1);
  const iframeRef = useRef();

  const sent = email?.sent;

  useEffect(() => {
    return () => {
      if (isEmailsPage)
        navigate(`${RouterConfig.emails}${location.search ?? ""}`);
    };
  }, []);

  if (!email)
    return (
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          flex: 1,
          justifyContent: "center",
        }}
      >
        <CircularProgress />
      </Box>
    );
  const getHeader = () => (
    <Sheet
      variant="soft"
      sx={{
        padding: 1,
        background: "white",
        display: "flex",
        gap: 1,
        flexDirection: "column",
      }}
    >
      <Box sx={{ display: "flex", gap: 1, justifyContent: "space-between" }}>
        <Box sx={{ display: "flex", gap: 1 }}>
          <Id startDecorator={<i className="fa-solid fa-envelope"></i>}>
            {email.id}
          </Id>
          <Typography level="body2">
            Created on {moment(email.createdAt).format("lll")}
          </Typography>
        </Box>
        <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
          <Tooltip
            title={
              !sent
                ? `${email.failCount} attempt${email.failCount > 1 ? "s" : ""}`
                : "Email Successfully Sent!"
            }
          >
            <Badge badgeContent={email.failCount} color="danger" size="sm">
              <Chip
                size="sm"
                color={sent ? "success" : "warning"}
                variant="soft"
                startDecorator={
                  sent ? (
                    <i className="fa-solid fa-check"></i>
                  ) : (
                    <i className="fa-solid fa-spinner fa-spin-pulse"></i>
                  )
                }
              >
                {sent ? "Sent" : "Pending"}
              </Chip>
            </Badge>
          </Tooltip>
        </Box>
      </Box>
      <Grid container spacing={2}>
        <Grid item style={{ width: 92 }}>
          <Typography level="body2">From:</Typography>
        </Grid>
        <Grid item style={{ flex: 1 }}>
          <Typography level="body2">
            {email.sentFromName} ({email.sentFromEmail})
          </Typography>
        </Grid>
      </Grid>
      {to.length ? (
        <Grid container spacing={2}>
          <Grid item style={{ width: 92 }}>
            <Typography level="body2">To:</Typography>
          </Grid>
          <Grid item style={{ flex: 1 }}>
            <Typography level="body2">
              {to.map((t, i) => {
                return (
                  <Typography key={t} level="body2">
                    {t}
                  </Typography>
                );
              })}
            </Typography>
          </Grid>
        </Grid>
      ) : (
        []
      )}
      {cc.length ? (
        <Grid container spacing={2}>
          <Grid item style={{ width: 92 }}>
            <Typography level="body2">Cc:</Typography>
          </Grid>
          <Grid item style={{ flex: 1 }}>
            <Typography level="body2">
              {cc.map((t, i) => (
                <Typography key={t} level="body2">
                  {t}
                </Typography>
              ))}
            </Typography>
          </Grid>
        </Grid>
      ) : (
        []
      )}
      {bcc.length ? (
        <Grid container spacing={2}>
          <Grid item style={{ width: 92 }}>
            <Typography level="body2">Bcc:</Typography>
          </Grid>
          <Grid item style={{ flex: 1 }}>
            <Typography level="body2">
              {bcc.map((t, i) => (
                <Chip key={t} size="sm" variant="outlined">
                  {t}
                </Chip>
              ))}
            </Typography>
          </Grid>
        </Grid>
      ) : (
        []
      )}
      <Grid container spacing={2} alignItems="center">
        <Grid item style={{ width: 92 }}>
          <Typography level="body2">Subject:</Typography>
        </Grid>
        <Grid item style={{ flex: 1 }}>
          <Typography level="body2">
            <b>{email.subject}</b>
          </Typography>
        </Grid>
        <Box sx={{ flexGrow: 1 }}></Box>
        <Chip
          sx={{ color: "#fb8c00" }}
          size="sm"
          color="warning"
          variant="plain"
          onClick={() => {
            fetch(
              `${AppConfig.api.endpoint}/local420/members/me/repairs/email/${email.id}`,
              {
                credentials: "include",
                headers: {
                  "content-type": "application/json",
                  "accept-encoding": "gzip, deflate",
                },
                method: "GET",
              }
            ).then(() => setKey((i) => i + 1));
          }}
        >
          Can’t see the email?
        </Chip>
      </Grid>
    </Sheet>
  );

  const to = [];
  const cc = [];
  const bcc = [];

  email &&
    email.recipients &&
    email.recipients.forEach((e) => {
      if (e.cc) {
        cc.push(e?.emailAddress);
      } else if (e.bcc) {
        bcc.push(e?.emailAddress);
      } else {
        to.push(e?.emailAddress);
      }
    });

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        position: "relative",
        alignItems: "stretch",
        flex: 1,
      }}
    >
      <Box>{getHeader()}</Box>
      <Divider />
      <Box
        sx={{
          flexGrow: 1,
          width: "100%",
          display: "flex",
          position: "relative",
        }}
      >
        {email ? (
          <iframe
            key={key}
            title="Email Preview"
            ref={iframeRef}
            src={`${AppConfig.api.endpoint}/local420/members/me/emails/${email.id}/HTML`}
            style={{ flex: 1, border: "none" }}
          ></iframe>
        ) : (
          []
        )}
      </Box>
    </Box>
  );
}
